import { createFileRoute, redirect } from "@tanstack/react-router";

// Burresi has no public landing page. Authenticated users go straight to
// their dashboard; the `_app` route guard bounces anonymous visitors to
// `/login`, which is the only customer-facing surface this app exposes.
export const Route = createFileRoute("/")({
	beforeLoad: () => {
		throw redirect({ to: "/dashboard" });
	},
});
